import React, { FC } from "react";
import { useTranslation } from "react-i18next";
import Certificate from "./Certificate";
import Refresher from "./Refresher";
import Group from "./Group";

import TableComponent from "../TableComponent";
import type { CourseCertificate } from "../../api/compliance";

interface CertificateListProps {
  certificates: CourseCertificate[];
  coveredByParent?: boolean;
  coveredByParentCourseName?: string;
  header?: boolean;
  variant?: string;
}

const renderCertificate =
  (variant?: string, coveredByParent?: boolean, coveredByParentCourseName?: string) =>
  (courseCertificate: CourseCertificate) => {
    if (!courseCertificate) {
      return <React.Fragment />;
    }
    if (courseCertificate.group) {
      return <Group courseCertificate={courseCertificate} key={courseCertificate.id} />;
    } else if (courseCertificate.refreshers?.length) {
      return <Refresher courseCertificate={courseCertificate} key={courseCertificate.id} />;
    }
    return (
      <Certificate
        coveredByParent={coveredByParent}
        coveredByParentCourseName={coveredByParentCourseName}
        variant={variant}
        courseCertificate={courseCertificate}
        key={courseCertificate.id}
      />
    );
  };

const CertificateList: FC<CertificateListProps> = ({
  certificates,
  coveredByParent = false,
  coveredByParentCourseName,
  header = true,
  variant,
}) => {
  const { t } = useTranslation();
  const isBorderless = variant === "borderless";

  return (
    <TableComponent
      containerStyle={isBorderless ? { border: 0, overflowX: "hidden" } : undefined}
      header={
        header
          ? [
              { title: "", style: { width: "1rem" } },
              { title: t("certificate.name"), style: {} }, // Auto width for flexible spacing
              { title: t("certificate.validity_period"), style: { whiteSpace: "nowrap", width: "15%" } },
              { title: t("certificate.valid_until"), style: { width: "15%" } },
              { title: t("certificate.actions"), style: { width: "12%" } },
            ]
          : undefined
      }
      WrapperComponent={"div" as any}
      items={certificates?.map((cert) => ({ ...cert, key: cert.id }))}
      renderChildren={renderCertificate(variant, coveredByParent, coveredByParentCourseName)}
      tableStyle={{ tableLayout: "fixed", width: "100%" }}
    />
  );
};

export default CertificateList;
